import React, { useState } from 'react';
import { kiApi } from '../api';

export default function KiAnalyse({ ocrText, dokumentId, onUebernehmen }) {
  const [loading, setLoading] = useState(false);
  const [ergebnis, setErgebnis] = useState(null);
  const [fehler, setFehler] = useState(null);

  const handleAnalyse = async () => {
    if (!ocrText && !dokumentId) return;
    setLoading(true);
    setFehler(null);
    setErgebnis(null);
    try {
      let res;
      if (dokumentId) {
        res = await kiApi.analyseDokument(dokumentId);
      } else {
        res = await kiApi.analyse(ocrText);
      }
      setErgebnis(res.data.data);
    } catch (err) {
      setFehler(err.response?.data?.error || 'KI-Analyse fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  const handleUebernehmen = () => {
    if (ergebnis && onUebernehmen) {
      onUebernehmen(ergebnis);
    }
  };

  return (
    <div style={{ background: '#0f172a', borderRadius: 10, padding: '12px 14px', marginTop: 10, border: '1px solid #4f46e544' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
        <span style={{ color: '#818cf8', fontSize: 13, fontWeight: 600 }}>🤖 KI-Analyse</span>
        <button
          onClick={handleAnalyse}
          disabled={loading || (!ocrText && !dokumentId)}
          style={{
            background: loading ? '#334155' : '#4f46e522',
            color: loading ? '#64748b' : '#818cf8',
            border: '1px solid #4f46e544',
            padding: '6px 12px', borderRadius: 6,
            cursor: loading ? 'not-allowed' : 'pointer',
            fontSize: 12, fontWeight: 600,
          }}
        >
          {loading ? '⏳ Analysiere...' : '🔍 Vertrag analysieren'}
        </button>
      </div>

      {loading && (
        <div style={{ color: '#64748b', fontSize: 12, marginBottom: 8 }}>
          ⏳ Analyse läuft im Hintergrund... Das kann einen Moment dauern.
          <div style={{ background: '#1e293b', borderRadius: 4, height: 4, marginTop: 6, overflow: 'hidden' }}>
            <div style={{ background: '#6366f1', height: 4, width: '100%', animation: 'pulse 1.5s infinite' }} />
          </div>
        </div>
      )}

      {fehler && (
        <div style={{ background: '#ef444422', border: '1px solid #ef444444', borderRadius: 8, padding: '8px 12px', color: '#f87171', fontSize: 12 }}>
          ❌ {fehler}
        </div>
      )}

      {ergebnis && (
        <div>
          <div style={{ color: '#34d399', fontSize: 12, marginBottom: 8 }}>✅ Analyse abgeschlossen!</div>

          {ergebnis.zusammenfassung && (
            <div style={{ background: '#1e293b', borderRadius: 8, padding: '8px 12px', marginBottom: 10, color: '#cbd5e1', fontSize: 13, fontStyle: 'italic' }}>
              💬 {ergebnis.zusammenfassung}
            </div>
          )}

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, marginBottom: 10 }}>
            {[
              { label: 'Titel', key: 'titel' },
              { label: 'Anbieter', key: 'anbieter' },
              { label: 'Kosten', key: 'kosten', suffix: ' €' },
              { label: 'Intervall', key: 'zahlungsintervall' },
              { label: 'Beginn', key: 'vertragsbeginn' },
              { label: 'Ende', key: 'vertragsende' },
              { label: 'Kündigungsfrist', key: 'kuendigungsfrist_monate', suffix: ' Monate' },
              { label: 'Kundennummer', key: 'kundennummer' },
            ].filter(f => ergebnis[f.key]).map(f => (
              <div key={f.key} style={{ background: '#1e293b', borderRadius: 6, padding: '6px 10px' }}>
                <div style={{ color: '#64748b', fontSize: 10, marginBottom: 2 }}>{f.label}</div>
                <div style={{ color: '#f1f5f9', fontSize: 13, fontWeight: 500 }}>
                  {ergebnis[f.key]}{f.suffix || ''}
                </div>
              </div>
            ))}
          </div>

          {onUebernehmen && (
            <button
              onClick={handleUebernehmen}
              style={{
                background: '#10b98122', color: '#34d399',
                border: '1px solid #10b98144',
                padding: '8px 16px', borderRadius: 8,
                cursor: 'pointer', fontSize: 13, fontWeight: 600,
                width: '100%',
              }}
            >
              ✅ Daten ins Formular übernehmen
            </button>
          )}
        </div>
      )}
    </div>
  );
}
